import type { PlanValues } from 'api/elplan/elplan.types'
import Datetime from 'utils/datetime/datetime'
import { getDayQuarterStarts } from 'utils/datetime/dayTimeSteps'
import type { FormattedBidWithIdAndTitle } from '../../../DayAheadBidManagement/DayAheadBidManagement.helper'

export function getDefaultSpotBidQuarterValues(date: ISODateTime): Record<string, PlanValues> {
  const quarterValuesByStart: Record<string, PlanValues> = {}
  for (const quarterStart of getDayQuarterStarts(date)) {
    quarterValuesByStart[quarterStart] = {
      time: quarterStart,
      start_time: quarterStart,
      end_time: Datetime.addMinutes(quarterStart, 15),
      volume: 0,
      id: null,
    }
  }
  return quarterValuesByStart
}

export function spotBidsToPlanValues(databaseSpotBids: FormattedBidWithIdAndTitle[], date: ISODateTime): PlanValues[] {
  const array: PlanValues[] = []
  const quarterValuesByStart = getDefaultSpotBidQuarterValues(date)

  databaseSpotBids.forEach((spotBid) => {
    const startTimeISOString = Datetime.toISOString(spotBid.startTime)
    if (quarterValuesByStart[startTimeISOString]) {
      quarterValuesByStart[startTimeISOString].id = spotBid.id ?? null

      if (typeof spotBid.volume === 'number') {
        quarterValuesByStart[startTimeISOString].volume = spotBid.volume
      } else if (Array.isArray(spotBid.volume)) {
        quarterValuesByStart[startTimeISOString].volume = spotBid.volume[0]
      } else {
        quarterValuesByStart[startTimeISOString].volume = 0
      }
    }
  })

  for (const key in quarterValuesByStart) {
    array.push(quarterValuesByStart[key])
  }

  return array
}
